import { defineLanguage } from "../registry";

export default defineLanguage({
  id: "python",
  filenames: ["requirements.txt", "Pipfile", ".pythonrc"],
  runner: "python",
  config: {
    autoClosingPairs: [
      { open: "{", close: "}" },
      { open: "[", close: "]" },
      { open: "(", close: ")" },
      { open: '"', close: '"', notIn: ["string"] },
      { open: "'", close: "'", notIn: ["string", "comment"] },
      { open: '"""', close: '"""', notIn: ["string"] },
    ],
    // Indent after a colon, outdent after pass/return/raise/break/continue (as VS Code does).
    onEnterRules: [
      { beforeText: /:\s*(?:#.*)?$/, action: "indent" },
      { beforeText: /^\s*(?:pass|return|raise|break|continue)\b.*$/, action: "outdent" },
    ],
    indent: { size: 4 },
  },
});
